'use client';
import { LoadingBlockFullPage } from '@plato/ui-legacy/components/loading/loading-block-full-page';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AppProviders } from '../components/providers/app-providers.tsx';
import { ErrorBoundary } from '../features/error-boundary/error-boundary.tsx';
import '../styles/globals.css';

function MyApp() {
    return (
        <ErrorBoundary>
            <AppProviders>
                <Suspense fallback={<LoadingBlockFullPage />}>
                    <Outlet />
                </Suspense>
            </AppProviders>
        </ErrorBoundary>
    );
}

export default MyApp;
